import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 6rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  justify-content: center;

  .search_white {
    fill: #fff;
    margin-right: 4px;
  }
`;

export const Wrapper = styled.div`
  max-width: 22rem;
  width: 100%;
  height: fit-content;
  display: inline-flex;
  flex-flow: row nowrap !important;
  align-items: center;
  justify-content: center;
  position: relative;
  .search_input::-webkit-input-placeholder {
    color: #333;
  }
`;

export const SearchInput = styled.input`
  font-size: 13px;
  color: #333333;
  font-family: 'DINRegular';
  width: 100%;
  height: 3.125rem;
  padding-right: 4.375rem;
  padding-left: 1.25rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  border: none;
`;

export const SearchButton = styled.button`
  width: 3.125rem;
  height: 3.125rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: #000;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  span {
    background-image: url(/svg/sprites.svg#searchic);
    width: 50px;
    height: 50px;
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    padding: 0;
    margin: 0;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
`;
